import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button, Card, Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';
import React from 'react';

import { VentilasjonsType } from '../../../utils/registerEnums';
import {
  ButtonWrapper,
  CardContentWrapper,
  MainContentWrapper,
  StyledParagraph
} from '../../solceller/form/components/styledComponents';
import { FormErrors } from '../../../../form/formErrors';

import { BalansertVentilasjonInputs } from './balansertVentilasjonInput';
import { useVentilationSubmit } from './useVentilationSubmit';
import { VentilasjonFormData } from './types';

export const VentilasjonsForm = () => {
  const { t } = useTranslation();

  const methods = useForm<VentilasjonFormData>();
  const { register } = methods;
  const { onSubmit } = useVentilationSubmit();
  const isBalansertVentilasjon = methods.watch('ventilasjonType') === 'balansert';

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
        <StyledParagraph data-size="xs">{t('register.solar.form.allFieldsRequired')}</StyledParagraph>
        <MainContentWrapper>
          <Card>
            <CardContentWrapper>
              <Fieldset>
                <Fieldset.Legend>{t('register.ventilation.form.type.label')}</Fieldset.Legend>
                <Radio
                  {...register('ventilasjonType', { required: t('register.ventilasjon.form.type.error.missing') })}
                  label={t(`register.ventilation.form.type.${VentilasjonsType.Naturlig}`)}
                  value={VentilasjonsType.Naturlig}
                />
                <Radio
                  {...register('ventilasjonType', { required: t('register.ventilasjon.form.type.error.missing') })}
                  label={t(`register.ventilation.form.type.${VentilasjonsType.PeriodiskAvtrekk}`)}
                  value={VentilasjonsType.PeriodiskAvtrekk}
                />
                <Radio
                  {...register('ventilasjonType', { required: t('register.ventilasjon.form.type.error.missing') })}
                  label={t(`register.ventilation.form.type.${VentilasjonsType.MekaniskAvtrekk}`)}
                  value={VentilasjonsType.MekaniskAvtrekk}
                />
                <Radio
                  {...register('ventilasjonType', { required: t('register.ventilasjon.form.type.error.missing') })}
                  label={t(`register.ventilation.form.type.${VentilasjonsType.Balansert}`)}
                  value={VentilasjonsType.Balansert}
                />
                {
                  // Show additional input fields when "Balansert" is selected
                  isBalansertVentilasjon && <BalansertVentilasjonInputs />
                }

                <Radio
                  {...register('ventilasjonType', {
                    required: t('register.ventilation.form.type.error.missing')
                  })}
                  label={t(`register.ventilation.form.type.${VentilasjonsType.Ukjent}`)}
                  value={VentilasjonsType.Ukjent}
                />
                {methods.formState.errors.ventilasjonType && (
                  <ValidationMessage data-color="danger">
                    {methods.formState.errors.ventilasjonType.message}
                  </ValidationMessage>
                )}
              </Fieldset>
            </CardContentWrapper>
          </Card>
          <FormErrors errors={methods.formState.errors} />
          <ButtonWrapper>
            <Button variant="secondary">{t('register.solar.form.buttons.back')}</Button>
            <Button type="submit">{t('register.solar.form.buttons.continue')}</Button>
          </ButtonWrapper>
        </MainContentWrapper>
      </form>
    </FormProvider>
  );
};
